import { Turbo } from "@hotwired/turbo-rails"

Turbo.config.forms.confirm = (message) => {
  return new Promise((resolve) => {
    const modal = document.createElement("dialog")
    modal.className = "modal modal-bottom sm:modal-middle"
    modal.innerHTML = `
      <div class="modal-box">
        <h3 class="text-lg font-bold">${message}</h3>
        <div class="modal-action">
          <form method="dialog">
            <button class="btn btn-ghost" data-answer="false">Cancel</button>
          </form>
          <button type="button" class="btn btn-error" data-answer="true">Confirm</button>
        </div>
      </div>
    `
    modal.addEventListener("click", (e) => {
      const answer = (e.target as Element).closest("[data-answer]")?.getAttribute("data-answer")
      if (answer === undefined) return
      modal.close()
      modal.remove()
      resolve(answer === "true")
    })
    document.body.appendChild(modal)
    modal.showModal()
  })
}
